export default __webpack_public_path__ + "static/media/logout.36ef6bd8.svg";